'use strict';

var App = require('app');
var Company = require('models/company');
var AbstractTableView = require('components/common/views/abstract_table_view');
var Utils = require('components/common/utils');
var TokenStatsTemplate = require('components/profile/templates/api_token_stats');
var TokenAccessButtonsTemplate = require('components/profile/templates/api_token_access_btns');
var ApiTokenDialogView = require('components/profile/views/api_token_dialog_view');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var Strings = require('utils/strings');

var ApiTokenListView = AbstractTableView.extend({
    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click tr td a.js-name': 'changeAPItoken',
            'click #js-add': 'addNewAPItoken',
            'click .js-token-show': 'showApiToken',
            'click .js-token-copy': 'copyApiToken',
            'click .js-token-try': 'tryApiToken',
        });
    },

    collectionEvents: {
        sync: 'render',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.groups = options.groups ? options.groups.toJSON() : [];

        var self = this;
        AbstractTableView.prototype.initialize.apply(this, [
            {
                title: i18n.TR('API Token'),
                headingID: 'api-token',

                columns: [
                    {
                        id: '#_name',
                        name: 'Name', // i18n.TR('Name')
                        alwaysVisible: true,
                        displayMethod: 'nameLink',
                    },
                    {
                        id: '#_token',
                        name: 'Token', // i18n.TR('Token')
                        displayMethod: 'tokenAccessButtons',
                    },
                    {
                        id: '#_groups',
                        name: 'Gerätegruppen', // i18n.TR('Gerätegruppen')
                        displayMethod: 'groupsList',
                    },
                    {
                        id: '#_expiration',
                        name: 'Ablaufdatum', // i18n.TR('Ablaufdatum')
                        displayMethod: 'expiration',
                    },
                    {
                        id: '#_source_ip',
                        name: 'IP Bereich', // i18n.TR('IP Bereich')
                    },
                    {
                        id: '#_modbus_access',
                        name: 'Modbus-Zugriff', // i18n.TR('Modbus-Zugriff')
                        displayMethod: 'modbusAccess',
                    },
                    {
                        id: '#_stats',
                        name: 'Statistik', // i18n.TR('Statistik')
                        displayMethod: 'tokenStats',
                    },
                ],

                selectionButtons: [{ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' }],
                customButtons: [{ ButtonIcon: 'fa fa-plus', ButtonID: 'add' }],

                hasRefreshButton: true,
                hasSelectionButtons: true,

                displayMethods: {
                    nameLink: function (value, model) {
                        return { type: 'link', text: value, idx: model.id, class: 'js-name' };
                    },
                    tokenAccessButtons: function (value, model) {
                        return TokenAccessButtonsTemplate({ token: value });
                    },
                    groupsList: function (value, model) {
                        var result = [];
                        _.each(value, function (tokenGroup) {
                            _.each(self.groups, function (g) {
                                if (tokenGroup == g.id) {
                                    result.push('&#8226;&nbsp;' + Handlebars.escapeExpression(g.name));
                                }
                            });
                        });
                        return result.length == 0 ? '--' : result.sort().join('<br>');
                    },
                    expiration: function (value, model) {
                        return value == '0001-01-01T00:00:00Z' ? '--' : value.substring(0, 10);
                    },
                    modbusAccess: function (value, model) {
                        return value === true ? '<i class="fa fa-check-circle text-success"></i>' : '--';
                    },
                    tokenStats: function (value, model) {
                        return TokenStatsTemplate(value);
                    },
                },
            },
        ]);
    },

    changeAPItoken: function (e) {
        e.preventDefault();
        var id = parseInt($(e.currentTarget).attr('data-idx'));
        App.showModal(
            new ApiTokenDialogView({
                model: this.collection.get(id),
                groups: this.groups,
                newToken: false,
                cb: this.controller.saveApiToken,
            })
        );
    },

    addNewAPItoken: function (e) {
        e.preventDefault();
        App.showModal(
            new ApiTokenDialogView({
                model: new Company.APIToken(),
                groups: this.groups,
                newToken: true,
                cb: this.controller.saveApiToken,
            })
        );
    },

    showApiToken: function (e) {
        e.preventDefault();
        Utils.showConfirmationDialog({
            title: i18n.TR('API Token'),
            hint: e.currentTarget.id,
        });
    },

    copyApiToken: function (e) {
        e.preventDefault();
        Strings.copyToClipboard(e.currentTarget.id);
        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('API Token wurde in die Zwischenablage kopiert.'));
    },

    tryApiToken: function (e) {
        e.preventDefault();
        App.trigger('profile:api-spec', e.currentTarget.id);
    },
});

module.exports = ApiTokenListView;
